import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ContentStyled } from '../../styles';
import NotfoundScene from '../../../../screens/not-found';
import {
  ROUTES_PATH,
  FULLSCREEN_ROUTES,
  WITHOUT_MENUSCEEN_ROUTES,
} from '../../../../resources/routes-name';

export const ContentLayout = ({
  getTheme,
  sidebarMode,
  isFullScreenRoute,
  isWithOutScreenRoute,
}) => {
  return (
    <div>
      <Switch>
        <div>
          {/* Content สำหรับหน้าปกติ */}
          <ContentStyled
            fixed
            style={{
              ...getTheme.sidebar[sidebarMode],
              display: isFullScreenRoute || isWithOutScreenRoute ? 'none' : 'flex',
            }}
          >
            {Object.values(ROUTES_PATH)
              .filter(
                (route) =>
                  !FULLSCREEN_ROUTES.includes(route.KEY) &&
                  !WITHOUT_MENUSCEEN_ROUTES.includes(route.KEY),
              )
              .map((route) => (
                <Route exact key={route.KEY} path={route.PATH} component={route.COMPONENT} />
              ))}
          </ContentStyled>

          {/* Content สำหรับ Fullscreen */}
          <ContentStyled
            fixed
            fullscreen
            style={{
              ...getTheme.sidebar[sidebarMode],
              display: isFullScreenRoute ? 'flex' : 'none',
            }}
          >
            {Object.values(ROUTES_PATH)
              .filter((route) => FULLSCREEN_ROUTES.includes(route.KEY))
              .map((route) => (
                <Route exact key={route.KEY} path={route.PATH} component={route.COMPONENT} />
              ))}
          </ContentStyled>

          {/* Content สำหรับหน้าที่ไม่มีเมนู */}
          <ContentStyled
            fixed
            withoutMenu
            style={{
              ...getTheme.sidebar[sidebarMode],
              display: isWithOutScreenRoute ? 'flex' : 'none',
            }}
          >
            {Object.values(ROUTES_PATH)
              .filter((route) => WITHOUT_MENUSCEEN_ROUTES.includes(route.KEY))
              .map((route) => (
                <Route exact key={route.KEY} path={route.PATH} component={route.COMPONENT} />
              ))}
          </ContentStyled>
        </div>

        <Route path="*" key="NOT_FOUND" component={NotfoundScene} />
      </Switch>
    </div>
  );
};

export default ContentLayout;
